'use strict';

var cov_2ljzskvnnf = function () {
  var path = 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\main.js',
      hash = '5c9de0a106b85c728de4706f739081fb69ce8d9c',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\main.js',
    statementMap: {
      '0': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 13,
          column: 6
        }
      },
      '1': {
        start: {
          line: 7,
          column: 22
        },
        end: {
          line: 7,
          column: 34
        }
      },
      '2': {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 12,
          column: 7
        }
      },
      '3': {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 9,
          column: 37
        }
      },
      '4': {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 24
        }
      },
      '5': {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 36,
          column: 7
        }
      },
      '6': {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 30,
          column: 11
        }
      },
      '7': {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 35,
          column: 9
        }
      },
      '8': {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 48
        }
      },
      '9': {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 61
        }
      },
      '10': {
        start: {
          line: 38,
          column: 26
        },
        end: {
          line: 38,
          column: 87
        }
      },
      '11': {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 42,
          column: 32
        }
      },
      '12': {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 36
        }
      },
      '13': {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 46,
          column: 8
        }
      },
      '14': {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 25
        }
      },
      '15': {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 49,
          column: 8
        }
      },
      '16': {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 27
        }
      },
      '17': {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 91,
          column: 8
        }
      },
      '18': {
        start: {
          line: 51,
          column: 20
        },
        end: {
          line: 51,
          column: 53
        }
      },
      '19': {
        start: {
          line: 52,
          column: 19
        },
        end: {
          line: 52,
          column: 52
        }
      },
      '20': {
        start: {
          line: 53,
          column: 23
        },
        end: {
          line: 56,
          column: 9
        }
      },
      '21': {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 90,
          column: 11
        }
      },
      '22': {
        start: {
          line: 63,
          column: 10
        },
        end: {
          line: 89,
          column: 11
        }
      },
      '23': {
        start: {
          line: 64,
          column: 12
        },
        end: {
          line: 64,
          column: 47
        }
      },
      '24': {
        start: {
          line: 65,
          column: 12
        },
        end: {
          line: 65,
          column: 29
        }
      },
      '25': {
        start: {
          line: 66,
          column: 12
        },
        end: {
          line: 66,
          column: 37
        }
      },
      '26': {
        start: {
          line: 67,
          column: 12
        },
        end: {
          line: 71,
          column: 15
        }
      },
      '27': {
        start: {
          line: 72,
          column: 12
        },
        end: {
          line: 72,
          column: 29
        }
      },
      '28': {
        start: {
          line: 73,
          column: 12
        },
        end: {
          line: 76,
          column: 13
        }
      },
      '29': {
        start: {
          line: 74,
          column: 14
        },
        end: {
          line: 74,
          column: 68
        }
      },
      '30': {
        start: {
          line: 75,
          column: 14
        },
        end: {
          line: 75,
          column: 55
        }
      },
      '31': {
        start: {
          line: 78,
          column: 12
        },
        end: {
          line: 82,
          column: 15
        }
      },
      '32': {
        start: {
          line: 83,
          column: 12
        },
        end: {
          line: 88,
          column: 13
        }
      },
      '33': {
        start: {
          line: 84,
          column: 14
        },
        end: {
          line: 84,
          column: 31
        }
      },
      '34': {
        start: {
          line: 86,
          column: 14
        },
        end: {
          line: 86,
          column: 51
        }
      },
      '35': {
        start: {
          line: 87,
          column: 14
        },
        end: {
          line: 87,
          column: 31
        }
      },
      '36': {
        start: {
          line: 96,
          column: 0
        },
        end: {
          line: 105,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 4,
            column: 3
          }
        },
        loc: {
          start: {
            line: 4,
            column: 158
          },
          end: {
            line: 93,
            column: 3
          }
        },
        line: 4
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 6,
            column: 24
          },
          end: {
            line: 6,
            column: 25
          }
        },
        loc: {
          start: {
            line: 6,
            column: 37
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 6
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 15,
            column: 32
          },
          end: {
            line: 15,
            column: 33
          }
        },
        loc: {
          start: {
            line: 15,
            column: 49
          },
          end: {
            line: 36,
            column: 5
          }
        },
        line: 15
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 28,
            column: 14
          },
          end: {
            line: 28,
            column: 15
          }
        },
        loc: {
          start: {
            line: 28,
            column: 24
          },
          end: {
            line: 29,
            column: 9
          }
        },
        line: 28
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 29,
            column: 11
          },
          end: {
            line: 29,
            column: 12
          }
        },
        loc: {
          start: {
            line: 29,
            column: 17
          },
          end: {
            line: 30,
            column: 9
          }
        },
        line: 29
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 31,
            column: 20
          },
          end: {
            line: 31,
            column: 21
          }
        },
        loc: {
          start: {
            line: 31,
            column: 26
          },
          end: {
            line: 33,
            column: 7
          }
        },
        line: 31
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 33,
            column: 10
          }
        },
        loc: {
          start: {
            line: 33,
            column: 28
          },
          end: {
            line: 35,
            column: 7
          }
        },
        line: 33
      },
      '7': {
        name: 'DialogController',
        decl: {
          start: {
            line: 41,
            column: 13
          },
          end: {
            line: 41,
            column: 29
          }
        },
        loc: {
          start: {
            line: 41,
            column: 72
          },
          end: {
            line: 92,
            column: 5
          }
        },
        line: 41
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 44,
            column: 20
          },
          end: {
            line: 44,
            column: 21
          }
        },
        loc: {
          start: {
            line: 44,
            column: 32
          },
          end: {
            line: 46,
            column: 7
          }
        },
        line: 44
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 47,
            column: 22
          },
          end: {
            line: 47,
            column: 23
          }
        },
        loc: {
          start: {
            line: 47,
            column: 34
          },
          end: {
            line: 49,
            column: 7
          }
        },
        line: 47
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 50,
            column: 21
          },
          end: {
            line: 50,
            column: 22
          }
        },
        loc: {
          start: {
            line: 50,
            column: 33
          },
          end: {
            line: 91,
            column: 7
          }
        },
        line: 50
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 62,
            column: 16
          },
          end: {
            line: 62,
            column: 17
          }
        },
        loc: {
          start: {
            line: 62,
            column: 26
          },
          end: {
            line: 90,
            column: 9
          }
        },
        line: 62
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 12,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 12,
            column: 7
          }
        }, {
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 12,
            column: 7
          }
        }],
        line: 8
      },
      '1': {
        loc: {
          start: {
            line: 32,
            column: 15
          },
          end: {
            line: 32,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 32,
            column: 15
          },
          end: {
            line: 32,
            column: 29
          }
        }, {
          start: {
            line: 32,
            column: 33
          },
          end: {
            line: 32,
            column: 47
          }
        }],
        line: 32
      },
      '2': {
        loc: {
          start: {
            line: 38,
            column: 26
          },
          end: {
            line: 38,
            column: 87
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 38,
            column: 27
          },
          end: {
            line: 38,
            column: 41
          }
        }, {
          start: {
            line: 38,
            column: 45
          },
          end: {
            line: 38,
            column: 59
          }
        }, {
          start: {
            line: 38,
            column: 64
          },
          end: {
            line: 38,
            column: 87
          }
        }],
        line: 38
      },
      '3': {
        loc: {
          start: {
            line: 63,
            column: 10
          },
          end: {
            line: 89,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 63,
            column: 10
          },
          end: {
            line: 89,
            column: 11
          }
        }, {
          start: {
            line: 63,
            column: 10
          },
          end: {
            line: 89,
            column: 11
          }
        }],
        line: 63
      },
      '4': {
        loc: {
          start: {
            line: 73,
            column: 12
          },
          end: {
            line: 76,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 73,
            column: 12
          },
          end: {
            line: 76,
            column: 13
          }
        }, {
          start: {
            line: 73,
            column: 12
          },
          end: {
            line: 76,
            column: 13
          }
        }],
        line: 73
      },
      '5': {
        loc: {
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 88,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 88,
            column: 13
          }
        }, {
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 88,
            column: 13
          }
        }],
        line: 83
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MainController =
/** @ngInject */
function MainController($scope, moment, $http, ngNotify, $rootScope, $httpParamSerializer, apiOpen, $location, $anchorScroll, $mdDialog, localStorageService, $mdMedia) {
  _classCallCheck(this, MainController);

  cov_2ljzskvnnf.f[0]++;
  cov_2ljzskvnnf.s[0]++;


  $scope.gotoAnchor = function (x) {
    cov_2ljzskvnnf.f[1]++;

    var newHash = (cov_2ljzskvnnf.s[1]++, 'anchor' + x);
    cov_2ljzskvnnf.s[2]++;
    if ($location.hash() !== newHash) {
      cov_2ljzskvnnf.b[0][0]++;
      cov_2ljzskvnnf.s[3]++;

      $location.hash('anchor' + x);
    } else {
      cov_2ljzskvnnf.b[0][1]++;
      cov_2ljzskvnnf.s[4]++;

      $anchorScroll();
    }
  };

  cov_2ljzskvnnf.s[5]++;
  $rootScope.$on('CallLogin', function (event, data) {
    cov_2ljzskvnnf.f[2]++;
    cov_2ljzskvnnf.s[6]++;

    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'app/dialog.html',
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: false,
      fullscreen: useFullScreen,
      locals: {
        types: data
      }
    }).then(function (answer) {
      cov_2ljzskvnnf.f[3]++;
    }, function () {
      cov_2ljzskvnnf.f[4]++;
    });
    cov_2ljzskvnnf.s[7]++;
    $scope.$watch(function () {
      cov_2ljzskvnnf.f[5]++;
      cov_2ljzskvnnf.s[8]++;

      return (cov_2ljzskvnnf.b[1][0]++, $mdMedia('xs')) || (cov_2ljzskvnnf.b[1][1]++, $mdMedia('sm'));
    }, function (wantsFullScreen) {
      cov_2ljzskvnnf.f[6]++;
      cov_2ljzskvnnf.s[9]++;

      $scope.customFullscreen = wantsFullScreen === true;
    });
  });

  var useFullScreen = (cov_2ljzskvnnf.s[10]++, ((cov_2ljzskvnnf.b[2][0]++, $mdMedia('sm')) || (cov_2ljzskvnnf.b[2][1]++, $mdMedia('xs'))) && (cov_2ljzskvnnf.b[2][2]++, $scope.customFullscreen));

  function DialogController($scope, $mdDialog, types, $state, myVars) {
    cov_2ljzskvnnf.f[7]++;
    cov_2ljzskvnnf.s[11]++;

    $scope.checkinfo = myVars;
    cov_2ljzskvnnf.s[12]++;
    $scope.showClose = types.data;
    cov_2ljzskvnnf.s[13]++;
    $scope.hide = function () {
      cov_2ljzskvnnf.f[8]++;
      cov_2ljzskvnnf.s[14]++;

      $mdDialog.hide();
    };
    cov_2ljzskvnnf.s[15]++;
    $scope.cancel = function () {
      cov_2ljzskvnnf.f[9]++;
      cov_2ljzskvnnf.s[16]++;

      $mdDialog.cancel();
    };
    cov_2ljzskvnnf.s[17]++;
    $scope.login = function () {
      cov_2ljzskvnnf.f[10]++;

      var key = (cov_2ljzskvnnf.s[18]++, CryptoJS.lib.WordArray.random(16));
      var iv = (cov_2ljzskvnnf.s[19]++, CryptoJS.lib.WordArray.random(16));
      var member = (cov_2ljzskvnnf.s[20]++, {
        username: CryptoJS.AES.encrypt($scope.username, $rootScope.base64Key, { iv: $rootScope.iv }).ciphertext.toString(),
        password: CryptoJS.AES.encrypt($scope.password, $rootScope.base64Key, { iv: $rootScope.iv }).ciphertext.toString()
      });
      cov_2ljzskvnnf.s[21]++;
      $http({
        url: apiOpen + 'login',
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        transformRequest: $httpParamSerializer, data: member
      }).then(function (result) {
        cov_2ljzskvnnf.f[11]++;
        cov_2ljzskvnnf.s[22]++;

        if (result.data.status === '0') {
          cov_2ljzskvnnf.b[3][0]++;
          cov_2ljzskvnnf.s[23]++;

          myVars.msisdn = result.data.msisdn;
          cov_2ljzskvnnf.s[24]++;
          myVars.login = 1;
          cov_2ljzskvnnf.s[25]++;
          myVars.checkMember = '0';
          cov_2ljzskvnnf.s[26]++;
          ngNotify.set('Chào mừng 0' + result.data.msisdn, {
            position: 'top',
            type: 'success',
            duration: 3000
          });
          cov_2ljzskvnnf.s[27]++;
          $mdDialog.hide();
          cov_2ljzskvnnf.s[28]++;
          if (localStorageService.isSupported) {
            cov_2ljzskvnnf.b[4][0]++;
            cov_2ljzskvnnf.s[29]++;

            localStorageService.set('msisdn', result.data.msisdn);
            cov_2ljzskvnnf.s[30]++;
            localStorageService.set('islogin', true);
          } else {
            cov_2ljzskvnnf.b[4][1]++;
          }
        } else {
          cov_2ljzskvnnf.b[3][1]++;
          cov_2ljzskvnnf.s[31]++;

          ngNotify.set('Bạn chưa đăng ký dịch vụ hoặc mật khẩu không chính xác !', {
            position: 'top',
            type: 'error',
            duration: 3000
          });
          cov_2ljzskvnnf.s[32]++;
          if (types === true) {
            cov_2ljzskvnnf.b[5][0]++;
            cov_2ljzskvnnf.s[33]++;

            $mdDialog.hide();
          } else {
            cov_2ljzskvnnf.b[5][1]++;
            cov_2ljzskvnnf.s[34]++;

            $state.go('app', {}, { reload: true });
            cov_2ljzskvnnf.s[35]++;
            $mdDialog.hide();
          }
        }
      });
    };
  }
};

cov_2ljzskvnnf.s[36]++;


angular.module('app').component('app', {
  templateUrl: 'app/main.html',
  controller: MainController,
  bindings: {
    clipsData: '<',
    articleData: '<'
  }
});